"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateUser = void 0;
var hooks_1 = require("utils/hooks");
var useUpdateUser = function (uid) {
    var _a = __read((0, hooks_1.useSubmitter)('users', uid), 2), userSubmitter = _a[0], isSubmittingUser = _a[1];
    var _b = __read((0, hooks_1.useSubmitter)('public_users', uid), 2), publicProfileSubmitter = _b[0], isSubmittingPublicProfile = _b[1];
    return [
        function (newData) { return Promise.all([userSubmitter(newData), publicProfileSubmitter(newData)]); },
        isSubmittingUser || isSubmittingPublicProfile,
    ];
};
exports.useUpdateUser = useUpdateUser;
